<!--
  listing-bottom-navigation.vue

  2025-04-30: Added listener for 'close' event from listing-info-card to close dialog and adhere to linter
-->
<template>
  <v-app-bar
    class="listing-bottom-navigation"
    color="white"
    tag="nav"
    fixed
    bottom
    height="72"
  >
    <div>
      <div v-if="price">
        <span
          class="font-weight-semibold"
          v-text="toDisplayCurrency(price, settings)"
        />
        <span class="font-weight-semibold mx-1">/</span>
        <span>{{ $t("night") }}</span>
      </div>
      <div v-if="info">
        <small
          class="grey--text text--darken-1 text-decoration-underline"
          v-text="`${info.check_in} - ${info.check_out}`"
        />
      </div>
    </div>
    <v-spacer />
    <v-btn
      :color="actionsColor"
      class="text-capitalize white--text"
      elevation="0"
      large
      :block="!price"
      @click="dialog = true"
      >{{ $t("book_now") }}</v-btn
    >
    <v-dialog
      v-model="dialog"
      :fullscreen="isMobile"
      @keydown.esc="dialog = false"
      @close-dialog="dialog = false"
    >
      <slot></slot>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import FormattersMixin from "@/mixins/formatters-mixin";
import DeviceMixin from "@/mixins/device-mixin";
import stylesMixin from "@/mixins/styles-mixin";
import { mapState } from "vuex";
export default {
  name: "listing-bottom-navigation",
  mixins: [FormattersMixin, DeviceMixin, stylesMixin],
  props: {
    price: Number,
    info: Object,
    listing: Object,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
  },
};
</script>

<style scoped></style>
